var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportInterpretation2',{attrs:{"componentId":_vm.studentId,"componentName":_vm.componentName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }